import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, showUnselectedOptions = true, listingType, intl } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  const idSlug = heading.toLowerCase().replace(/ /g, '_');
  const isTaskListing = listingType === 'tasks';
  const optionLabels = options.map(option => option.label);
  const isExecutionFormatField = optionLabels.includes('Онлайн') && optionLabels.includes('Офлайн');

  const headingTranslationId = isExecutionFormatField
    ? 'ListingPage.executionFormatTitle'
    : isTaskListing
    ? 'ListingPage.detailsTitleTask'
    : 'ListingPage.detailsTitle';

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionSubheading}>
        {intl.formatMessage({ id: headingTranslationId })}
      </Heading>
      <PropertyGroup
        id={`ListingPage.${idSlug}`}
        ariaLabel={heading}
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
